<template>
  <span class="p-d-flex" style="max-width: 100%;">
    <AutoComplete
        style="max-width: 80%; height: 54px;"
        class="p-inputtext p-component postcode-search p-pr-0"
        type="text"
        name="pos_zip_code"
        placeholder="Ville, Code postal"
        :suggestions="suggestions"
        field="label"
        forceSelection
        :minLength="2"
        @complete="autoCompleteLocation"
        v-model="internalSearchValue"
        @keyup.enter="onDoSearch"
        @item-select="onItemSelected"
    >
    </AutoComplete>
    <span class="p-d-inline-flex p-jc-center p-ai-center">
      <a class="p-button p-component p-button-icon-only b-button-rounded p-button-secondary" @click="onDoSearch" style="border-radius: 0 10px 10px 0; height: 40px;">
        <i class="p-button-icon pi pi-search"></i>
      </a>
    </span>
  </span>
</template>

<script>
export default {
  name: "SearchField.vue",
  props: {
    searchValue: {
      type: String,
      default: '',
    },
    geocodingService: Object
  },
  data () {
    return {
      suggestions: [],
      internalSearchValue: ''
    }
  },
  mounted () {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);

    if (params.get('near')) {
      let { query } = {query: params.get('near')}
      this.geocodingService.forwardGeocode({
        query,
        mode: 'mapbox.places',
        types: ['postcode', 'locality', 'place'],
        countries: ['FR'],
        language: ['FR']
      }).send().then(async (geocode) => {
        if (geocode.body && geocode.body.features && geocode.body.features.length > 0) {
          this.internalSearchValue = {
              label: geocode.body.features[0].place_name,
              value: geocode.body.features[0]
          }
          window.setTimeout(() => {
            if (window.storeLocatorBus) {
              window.storeLocatorBus.on('mapReady', async () => {
                await this.$emit('update-search', geocode.body.features[0])
                await this.$emit('do-search', geocode.body.features[0])
              })
            }
          }, 1000)
        }
      })
    }
  },
  methods: {
    async onSearchInput (e) {
      this.$emit('update-search', e.value.value)
    },
    autoCompleteLocation (e) {
      const { query } = e
      if (query) {
        if (this.geocodingService) {
          this.geocodingService.forwardGeocode({
            query,
            mode: 'mapbox.places',
            types: ['postcode', 'locality', 'place'],
            countries: ['FR'],
            language: ['FR']
          }).send().then((geocode) => {
            console.log('then')
            if (geocode.body && geocode.body.features && geocode.body.features.length > 0) {
              this.suggestions = geocode.body.features.map((f) => {
                return {
                  label: f.place_name,
                  value: f
                }
              })
            } else {
              this.suggestions = []
            }
          })
          .catch((e) => {
            console.error(e)
          })
        }
      }
    },
    onDoSearch () {
      this.$emit('do-search', this.searchValue)
    },
    async onItemSelected (e) {
      await this.$emit('update-search', e.value.value)
      this.$emit('do-search', e.value.value)
    }
  }
}
</script>

<style scoped>
.p-autocomplete.p-inputwrapper {
  background-color: transparent;
  border: none;
}
.pi.pi-search {
  cursor: pointer
}

</style>
